// -- transactions

export const adminTransactions = permissions => {
  if (permissions.admin_transactions) {
    return true
  }

  return false
}

export const modTransactions = permissions => {
  if (permissions.mod_transactions) {
    return true
  }

  return adminTransactions(permissions)
}

export const comTransactions = permissions => {
  if (permissions.community_transactions) {
    return true
  }

  return false
}

export const comStats = permissions => {
  if (permissions.community_stats) {
    return true
  }

  return false
}

export const comUser = permissions => {
  if (permissions.community_user) {
    return true
  }

  return false
}

export const comGroup = permissions => {
  if (permissions.community_group) {
    return true
  }

  return false
}

// -- community

export const adminCom = permissions => {
  if (permissions.admin_community) {
    return true
  }

  return false
}

export const modCom = permissions => {
  if (permissions.mod_community) {
    return true
  }

  return adminCom(permissions)
}

export const comSettings = permissions => {
  if (permissions.community_settings) {
    return true
  }

  return modCom(permissions)
}

export const supportAdmin = permissions => {
  if (permissions.supportAdmin) {
    return true
  }

  return false
}

export const supportAgent = permissions => {
  if (permissions.support_agent) {
    return true
  }

  return supportAdmin(permissions)
}

export const comSupport = permissions => {
  if (permissions.community_support) {
    return true
  }

  return false
}

// -- blog

export const adminBlog = permissions => {
  if (permissions.admin_blog) {
    return true
  }

  return false
}

export const modBlog = permissions => {
  if (permissions.mod_blog) {
    return true
  }

  return adminBlog(permissions)
}

// -- settings

export const adminSettings = permissions => {
  if (permissions.admin_settings) {
    return true
  }

  return false
}

export const modSettings = permissions => {
  if (permissions.mod_settings) {
    return true
  }

  return adminSettings(permissions)
}

// -- user

export const modGroups = permissions => {
  if (permissions.mod_groups) {
    return true
  }

  return adminGroups(permissions)
}

export const adminGroups = permissions => {
  if (permissions.admin_groups) {
    return true
  }

  return false
}

export const adminUser = permissions => {
  if (permissions.admin_user) {
    return true
  }

  return false
}

export const modUser = permissions => {
  if (permissions.mod_user) {
    return true
  }

  return adminUser(permissions)
}

export default {
  adminTransactions,
  modTransactions,
  comTransactions,
  comStats,
  comUser,
  comGroup,

  adminCom,
  modCom,
  comSettings,

  supportAdmin,
  supportAgent,
  comSupport,

  adminBlog,
  modBlog,

  adminSettings,
  modSettings,

  adminGroups,
  modGroups,

  adminUser,
  modUser
}



// WEBPACK FOOTER //
// ./src/utils/access.js